import React from 'react';
import PropTypes from 'prop-types';
import { Image as ImageComponent } from '@thd-olt-component-react/image';

import './customer-image-overlay.scss';

class MainImage extends React.Component {

  myRef = React.createRef();

  componentDidMount() {
    this.imageCenter();
    this.enableSwipe();
  }

  componentDidUpdate() {
    this.imageCenter();
  }

  componentWillUnmount() {
    this.HammerTime.off('swipe', this.handleSwipe);
  }

  imageCenter = () => {
    const { photoUrl } = this.props;
    const imgElement = this.myRef.current;
    if (imgElement?.children && photoUrl) {
      const imgContainer = imgElement.children[0];
      let img = new Image();
      const measureImg = function () {
        imgContainer.className = (this.naturalHeight > this.naturalWidth) ? 'vertical' : 'horizontal';
        img.removeEventListener('load', measureImg);
      };
      img.addEventListener('load', measureImg);
      img.src = photoUrl;
    }
  };

  enableSwipe = async () => {
    if (this.myRef.current !== null) {
      const Hammer = await import(/* webpackChunkName: "hammerjs" */ 'hammerjs');
      // eslint-disable-next-line new-cap
      this.HammerTime = new Hammer.default(this.myRef.current);
      this.HammerTime.on('swipe', this.handleSwipe);
    }
  }

  handleSwipe = (event) => {
    const { getNextImage, getPreviousImage, interactionHandler, interactionTypes } = this.props;
    const { SWIPE_NEXT, SWIPE_PREVIOUS } = interactionTypes;
    const { direction } = event;
    if (direction === 2) {
      getNextImage();
      interactionHandler(SWIPE_NEXT);
    } else if (direction === 4) {
      getPreviousImage();
      interactionHandler(SWIPE_PREVIOUS);
    }
  }

  render() {
    const { photoUrl } = this.props;
    return (
      <div className="center" ref={this.myRef}>
        <ImageComponent src={photoUrl} alt="" height="1" width="1" />
      </div>
    );
  }

}
MainImage.propTypes = {
  photoUrl: PropTypes.string,
  getNextImage: PropTypes.func.isRequired,
  getPreviousImage: PropTypes.func.isRequired,
  interactionHandler: PropTypes.func.isRequired,
  interactionTypes: PropTypes.shape({
    SWIPE_NEXT: PropTypes.string,
    SWIPE_PREVIOUS: PropTypes.string,
  }).isRequired,
};

MainImage.defaultProps = {
  photoUrl: '',
};
export { MainImage };
